module.exports = __webpack_public_path__ + "img/city.dd6bc937.jpg";